import React from 'react';

const Notes = () => {
  return <h1>Notes Page</h1>;
};

export default Notes;
